import Vue from 'vue';
import Vuex from 'vuex';
import {
  mapGetters
} from 'vuex';
import _ from 'lodash';
import {
  getDevice,
  isWeixin,
  isLogin,
  isBind,
  isSafari,
  clientType
} from '@/config/utils';
Vue.use(Vuex);

const state = {
  isWx: isWeixin(),
  isPc: false, // 是否pc访问
  app_token: '', // token
  wechatToken: '', // jssdk token
  isLoading: false,
  topicType: "1", // 话题类型
  device: getDevice(),
  maskView: "none",
  direction: 'forward',
  wxSignUrl: null,
  openId: '',
  // cacheArr: ['familyPolicy', 'paymentList', 'renewal'],
  cacheArr: [],
  custId: '',
  loginStatus: isLogin(), // 登陆状态 T/F
  isSafari: isSafari(),
  isAppClientType: false,
  clientType: clientType(),
  isBind: isBind(),
  userInfo: null,
  jumpInfo: null,
  jumpParameter: "",
  userType: -1, // 用户状态 1司内代理人 2有托管 3有服务邀请的客户 4有交易的客户 5小白客户 6重复预约客户 8 服务关系的客户
  channelType: 2, // 渠道类型，区分童管家 还是保险咨询  1大童保险咨询  2 大童保险管家,
  promiseDailog: {
    userName: null,
    showBind: false,
    index: -1,
  },
  hasRead: true,
  hassvRead: false,
  hostRead: false,
  changeHostRead: false,
  isFirstPage: -1,
  isCertification: false,
  locationInfo: null,
  invoiceInfo: null,
  invoiceHisInfo: null,
  svOrderIdList: [],
  scrolledTop: 0, // 我家保单、交费详情、续保提醒页面 当前滑动距离
  agreeStatus: false, // 保单上传协议状态 默认false,上传一次之后为true
  hasShowDailog: false, // 收费展示过 保障期限小于一年的保单不会自动同步 弹框 默认false,上传一次之后为true
  errorTips: false,
  redPoint: false,
  centercationRead: false,
	wechatSignUrl:''
};

const mutations = {
  setToken(state, data) {
    state.app_token = data.accessToken;
  },
  // 点击清除之前所有缓存的页面
  clearCacheArr(state) {
    state.cacheArr = []
  },
  // 清空缓存后再将待缓存的页面添加
  setCacheArr(state) {
    state.cacheArr = []
  },
  setUrl(state, data) {
    state.wxSignUrl = data
  },
  clearCacheByName(state, pageName) {
    const cacheList = state.cacheArr;
    for (let i = 0; i < cacheList.length; i++) {
      if (cacheList[i] === pageName) {
        cacheList.splice(i, 1);
      }
    }
  },
  setCacheByName(state, pageName) {
    if (!state.cacheArr.includes(pageName)) {
      state.cacheArr.push(pageName);
    }
  },
  // 按钮遮罩显示
  showMaskView(state) {
    state.maskView = 'block'
  },
  // 按钮遮罩隐藏
  hideMaskView(state) {
    state.maskView = 'none'
  },
  // 路由跳转加载
  updateLoadingStatus(state, payload) {
    state.isLoading = payload.isLoading
  },
  // 改变进出栈方向
  updateDirection(state, payload) {
    state.direction = payload.direction
  },
  // 存储客户列表客户信息
  saveCustomerData(state, payload) {
    state.customerData = payload
  },
  // 保存登陆状态
  saveLoginStatus(state, status) {
    state.loginStatus = status
  },
  // 保存绑定状态
  saveBindStatus(state, status) {
    state.isBind = status
  },
  // 设置clientType
  setclientType(state, value) {
    state.isWx = value
  },
  // 设置app clientType
  setAppClientType(state, value) {
    state.isAppClientType = value;
  },
  setErrorTips(state, value) {
    state.errorTips = value
  },
	setWechatSignUrl(state, wechatSignUrl) {
		//const u = navigator.userAgent;
		//let isIos = u.indexOf("iPhone") > -1 || u.indexOf("Mac OS") > -1;
		//if ((isIos && !state.wechatSignUrl) || !isIos) {
			state.wechatSignUrl = wechatSignUrl;
	//	}
	},

};

const actions = {};
const getters = {
  getUserType: (state) => {
    return state.userType;
  },
  getJumpInfo: (state) => {
    return state.jumpInfo;
  },
  userState: (state) => {
    const Obj = {
      userType: state.userType,
      bindState: state.jumpInfo && state.jumpInfo.state,
    };
    return Obj;
  },
	getWechatSignUrl:(state)=>{
  		return state.wechatSignUrl;
	}
};

export default new Vuex.Store({
  state,
  actions,
  mutations,
  getters,
});



// WEBPACK FOOTER //
// ./src/store/index.js